import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './EvServiceEditor.html?raw';
import on from 'dojo/on';
import Edit from '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import SelectBox from '../../../moreCore/UI/SelectBox/SelectBox';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import MultiselectBox from '../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import "../../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox";
import { MainCatalogTypes, MainCatalogs_Classes, EvService_Types } from "../../_loadingHelpers/MainCatalogTypes";
import MultiLangEdit from '../../../moreCore/UI/MultiLangEdit/MultiLangEdit';


interface EvServiceCategoryEntry
{
    categoryID: string;
    categoryColor: more.EntityAPIColor;
    assignmentID: string;
    description: string;
    isMainCategory: boolean;
    isDeleted?: boolean;
    blobNode?: HTMLElement;
    blobIcon?: HTMLElement;
}
class EvServiceEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    //input_Description_D: Edit;
    //input_Description_E: Edit;

    input_Description_MultiLang: MdsLax<InstanceType<typeof MultiLangEdit<MainCatalogTypes.EvService_EntityData>>>;

    input_BookingNoteInt: MdsLax<InstanceType<typeof Edit>>;
    input_BookingNoteExt: MdsLax<InstanceType<typeof Edit>>;
    //input_TextColor: HTMLInputElement;
    //input_BackgroundColor: HTMLInputElement;
    input_Type: MdsLax<InstanceType<typeof SelectBox>>;
    input_Unit: MdsLax<InstanceType<typeof SelectBox>>;
    input_TaskDescript: MdsLax<InstanceType<typeof SearchSelect>>;
    input_Order: MdsLax<InstanceType<typeof NumberInput>>;
    input_Price: MdsLax<InstanceType<typeof NumberInput>>;
    checkbox_FreePricePosition: MdsLax<InstanceType<typeof CheckBox>>;
    input_Category: MdsLax<InstanceType<typeof MultiselectBox>>;
    inputCategoriesContainer: HTMLElement;
    categoriesContainer: HTMLElement;
    maincategoryContainer: HTMLElement;
    sectionTypeDefault: HTMLElement;
    taskDescriptMainContainer: HTMLElement;

    private sourceData: MainCatalogTypes.EvService_EntityData = null;
    selectedCategories: Array<EvServiceCategoryEntry> = [];

    formData: MainCatalogTypes.EvService_EntityData = {
        ID: "",
        is_new_entity: null,
        displayname: "",
        description_D: "",
        description_E: "",
        order: null,
        categories: [],
        is_external_usage: null,
        is_internal_usage: null,
        is_free_price_position: null,
        taskDescriptID: null,
        service_type: null,
        note: "",
        quantity: -1,
        quantity_multiplier: -1,
        ref_service_unit: null,
        ev_service_text_external: "",
        ev_service_text_internal: "",
        ev_service_infotext: "",
        ev_service_text_booking: "",
        //priceGroups: null
        price_net: null,
        __multilang: {}
    };

    prepareFormData(data?: MainCatalogTypes.EvService_EntityData): void {

        this.selectedCategories = [];
        let taskDescrID: string = null;

        //if (!data) {
        //    data = this.sourceData;
        //}

        if (data) {
            this.sourceData = data;
            this.formData = data;
            this.selectedCategories = data.categories;

            //this.input_Description_D.setValue(data.description_D, true);
            //this.input_Description_E.setValue(data.description_E, true);
            this.input_Description_MultiLang.setValue({ entity: data, targetAttribute: "description" });
            console.log(this.input_Description_MultiLang.getValue());
            this.input_Order.setValue(data.order, true);
            this.input_Type.setValue(data.service_type?.toString(), true);

            this.input_BookingNoteInt.setValue(data.ev_service_text_internal, true);
            this.input_BookingNoteExt.setValue(data.ev_service_text_external, true);

            this.input_Unit.setValue(data.ref_service_unit?.ID, true);

            this.checkbox_FreePricePosition.setValue(data.is_free_price_position, true);

            let alreadySelectedCategories: Array<string> = (<Array<EvServiceCategoryEntry>>this.selectedCategories).map(function (assignment) {
                return assignment.categoryID;
            });
            
            if (this.input_Category.entries) this.input_Category.setValue(alreadySelectedCategories, true);

            //this.input_TaskDescript.setCatalog(MainCatalogs_Classes.EvTaskDescript,
            //    this.translations["General_Label_EvTaskDescript"], true, data.taskDescriptID);
            this.input_TaskDescript.loadListValues(data.taskDescriptID, true);
            taskDescrID = data.taskDescriptID;

            this.input_Price.setValue(data.price_net, true);

        } else {

            this.formData.ID = "";
            this.formData.is_new_entity = true;

            //this.input_Description_D.setValue("", true);
            //this.input_Description_E.setValue("", true);
            this.input_Description_MultiLang.setValue({ entity: null, targetAttribute: "description" });
            this.input_Order.setValue(null, true);
            this.input_Type.setValue("", true);

            this.input_BookingNoteInt.setValue("", true);
            this.input_BookingNoteExt.setValue("", true);

            this.checkbox_FreePricePosition.setValue(false, true);

            let alreadySelectedCategories: Array<string> = (<Array<EvServiceCategoryEntry>>this.selectedCategories).map(function (assignment) {
                return assignment.categoryID;
            });
            if (this.input_Category.entries) this.input_Category.setValue(alreadySelectedCategories);

            //this.input_TaskDescript.setCatalog(MainCatalogs_Classes.EvTaskDescript,
            //    this.translations["General_Label_EvTaskDescript"], true);
            //this.input_TaskDescript.setValue(null);
            this.input_TaskDescript.loadListValues();

            this.input_Price.setValue(null, true);
        }

        //if (this.input_TaskDescript) {
        //    this.input_TaskDescript.setEditButtonVisibility(true);
        //}

        this.setInputVisibilityByType();

        this.serializeFormData(taskDescrID);
        this.formData.categories.forEach((x: EvServiceCategoryEntry) => { x.isDeleted = false; }); //????????
        this.originalData = JSON.stringify(this.formData);
        //console.debug("EvService_LoadData + Formdata", data, this.originalData);

        this.StandbyStop();
        this.checkDirty();
    }

    private addCategoryBlob(categoryAssignment: EvServiceCategoryEntry) {

        let blob = this.UiModder.domConstruct.create("div", {
            className: "flex_row_center round nowrap border",
            order: 100
        }, categoryAssignment.isMainCategory ? this.maincategoryContainer : this.categoriesContainer);

        let blobX = this.UiModder.domConstruct.create("button", {
            className: "mds-button-base mds-hover-dark warningTXT round",
            innerHTML: "<i class='fas fa-times'></i>"
        }, blob);
        on(blobX, "click", lang.hitch(this, this._onClick_RemoveCategory, categoryAssignment));

        let blobMainSwitch = this.UiModder.domConstruct.create("div", {
            className: "", //"mds-button-base mds-hover-dark transparent",
            innerHTML: ""
        }, blob);
        let blobMainSwitchIcon = this.createFontawesomeIcon("fas fa-star w3-small paddingSmall", "", blobMainSwitch);

        //on(blobMainSwitch, "click", lang.hitch(this, this._onClick_MainCategory, categoryAssignment, !categoryAssignment.isMainCategory))

        // Hauptkategorie? 
        this.UiModder.domClass.toggle(blobMainSwitchIcon, "w3-hide", !categoryAssignment.isMainCategory); // regular: wenn es nicht maincategory ist
        //this.UiModder.domClass.toggle(blob, "bold darkBorder", categoryAssignment.isMainCategory);

        // gelöscht?
        this.UiModder.domClass.toggle(blob, "strike w3-disabled", categoryAssignment.isDeleted === true);

        let blobLabel = this.UiModder.domConstruct.create("div", {
            className: "paddingSmall",
            innerHTML: categoryAssignment.description
        }, blob);

        if (!categoryAssignment.isMainCategory) {
            this.UiModder.domClass.toggle(blobLabel, "mds-hover-dark", true);// !categoryAssignment.isMainCategory);
            on(blobLabel, "click", lang.hitch(this, this._onClick_MainCategory, categoryAssignment, true));
        }


        if (categoryAssignment.categoryColor) {
            let colorHexBG = categoryAssignment.categoryColor.BackColor?.Hex;
            let colorHexTXT = categoryAssignment.categoryColor.TextColor?.Hex;

            if (colorHexBG) {
                this.UiModder.domStyle.set(blob, "backgroundColor", colorHexBG);
            }

            if (colorHexTXT) {
                this.UiModder.domStyle.set(blobLabel, "color", colorHexTXT);
            }
        }
    }

    private drawSelectedCategoryBlobs(data?: MainCatalogTypes.EvService_EntityData) {

        if (!data) {
            data = this.formData;
        }
        
        this.UiModder.domConstruct.empty(this.categoriesContainer);
        this.UiModder.domConstruct.empty(this.maincategoryContainer);

        let categoryIds: Array<string> = [];

        if (data) {
            for (let assignedCategory of <Array<EvServiceCategoryEntry>>data.categories) {
                // wir benötigen:
                // categoryIds (nicht assignment) für das Searchselect, damit die dort vorausgewählt sind
                // und wir erstellen die Blobs für schnellere Übersicht

                if (!assignedCategory.isDeleted) {
                    categoryIds.push(assignedCategory.categoryID);
                }

                this.addCategoryBlob(
                    assignedCategory
                );
            }
        }        
    }


    private _onClick_RemoveCategory(targetAssignment: EvServiceCategoryEntry) {
        
        let selectedIDs: Array<string> = [];

        //for (let index = 0; index < this.selectedCategories.length; index++) {
        //    let categoryAssignment: EvServiceCategoryEntry = this.selectedCategories[index];

        //    if (categoryAssignment.categoryID == targetAssignment.categoryID) {
        //        if (categoryAssignment.assignmentID) {
        //            categoryAssignment.isDeleted = true;
        //        } else {
        //            this.selectedCategories.splice(index, 1);
        //        }
        //    } else {
        //        selectedIDs.push(categoryAssignment.categoryID);
        //    }
        //}

        let deletedCategory = this.selectedCategories.filter(x => x.categoryID === targetAssignment.categoryID)[0];

        deletedCategory.assignmentID ? deletedCategory.isDeleted = true : this.selectedCategories.splice(this.selectedCategories.indexOf(deletedCategory), 1);

        this.selectedCategories.forEach(categoryAssignment => {

            if (categoryAssignment.isDeleted !== true) selectedIDs.push(categoryAssignment.categoryID);
        });

        this.input_Category.setValue(selectedIDs);
    }

    private _onClick_MainCategory(assignment: EvServiceCategoryEntry, targetState: boolean) {
        
        for (let categoryAssignment of <Array<EvServiceCategoryEntry>>this.selectedCategories) {
            categoryAssignment.isMainCategory = false;

            if (categoryAssignment.categoryID == assignment.categoryID) {
                categoryAssignment.isMainCategory = true;
            }
        }

        this.drawSelectedCategoryBlobs();

        this._onChangeInputDataGeneric();
    }

    private _onChangeInput_Categories(newValues: Array<string>) {


        let entityValues = this.input_Category.getValue(true);
        let labelProp = this.input_Category.labelAttribute;
        let valueProp = this.input_Category.valueAttribute;
        console.log("_onChangeInput_Categories", newValues, entityValues);

        let missingCategories: Array<string> = [];
        let alreadySelectedCategories: Array<string> = (<Array<EvServiceCategoryEntry>>this.selectedCategories).map(function (assignment) {
            return assignment.categoryID;
        });

        let newAssignmentArray: Array<EvServiceCategoryEntry> = [];

        //for (let index = 0; index < this.selectedCategories.length; index++) {
        //    let categoryAssignment: EvServiceCategoryEntry = this.selectedCategories[index];

        //    if (categoryAssignment.assignmentID) {
        //        categoryAssignment.isDeleted = newValues.indexOf(categoryAssignment.categoryID, 0) == -1;
        //    } 

        //    newAssignmentArray.push(categoryAssignment);
        //}

        this.selectedCategories.forEach(categoryAssignment => {

            if (categoryAssignment.assignmentID) {

                categoryAssignment.isDeleted = newValues.indexOf(categoryAssignment.categoryID) == -1;
            }

            if ((newValues.length > 0 && newValues.indexOf(categoryAssignment.categoryID) > -1) || categoryAssignment.isDeleted !== undefined) {

                newAssignmentArray.push(categoryAssignment);
            }
        });

        for (let entity of entityValues) {
            if (alreadySelectedCategories.indexOf(entity[valueProp]) == -1) { // bisher noch nicht zugeordnet - neuer Eintrag!
                newAssignmentArray.push({
                    assignmentID: null,
                    categoryID: entity[valueProp],
                    categoryColor: entity.coloration,
                    description: entity[labelProp],
                    isMainCategory: newAssignmentArray.length == 0
                });
            }
        }

        //this.formData.categories = newAssignmentArray;
        this.selectedCategories = newAssignmentArray;

        this.serializeFormData();
        this.checkDirty();

        this.drawSelectedCategoryBlobs();
    }

    private _onChangeInputType(value: string) {
        // wenn sich der Typ ändert, müssen auch einige Inputs ein- und ausgeblendet werden

        this._onChangeInputDataGeneric();

        this.setInputVisibilityByType();
    }

    _onChangeInputNoteData(): void {

        this.fixNewLineInMultilineEdit(this.input_BookingNoteExt);
        this.fixNewLineInMultilineEdit(this.input_BookingNoteInt);

        this._onChangeInputDataGeneric();
    }

    private setInputVisibilityByType(): void {

        let selectedType = this.input_Type.getValue();

        let hideSection = selectedType != "1";

        this.UiModder.domClass.toggle(this.sectionTypeDefault, "w3-hide w3-disabled", hideSection);
    }

    serializeFormData(taskDescrID?: string): void {

        //this.formData.description_D = this.input_Description_D.getValue();
        //this.formData.description_E = this.input_Description_E.getValue();

        //this.formData.__multilang["description"] = this.input_Description_MultiLang.getValue();
        this.input_Description_MultiLang.getValueOntoEntity(this.formData as any);

        this.formData.ev_service_text_external = this.input_BookingNoteExt.getValue();
        this.formData.ev_service_text_internal = this.input_BookingNoteInt.getValue();

        this.formData.order = this.input_Order.getValue();
        this.formData.service_type = EvService_Types[this.input_Type.getValue()] as any;

        this.formData.taskDescriptID = this.input_TaskDescript.getValue();
        taskDescrID ? this.formData.taskDescriptID = taskDescrID : this.formData.taskDescriptID = this.input_TaskDescript.getValue();

        this.formData.categories = this.selectedCategories;

        //this.formData.priceGroups = this.input_Price.getValue();
        this.formData.price_net = this.input_Price.getValue();

        this.formData.ref_service_unit = { ID: "", code: "", description: "" };
        this.formData.ref_service_unit.ID = this.input_Unit.getValue();

        this.formData.is_free_price_position = this.checkbox_FreePricePosition.getValue();

        //console.debug("Ev_Service SERIALIZED DATA", this.formData);
    }



    isValid(): boolean {

        let b: boolean = true;


        return b;
    }

    private loadReferenceCatalogs(): void {
        let data = { "entityClass": this.entityClass, "ID": this.entityId };
        let requestUrl = window.appRoot + "MainCatalogsEditor/GetEvServiceCatalogs";
        //this.StandbyStart();
        this.UiModder.domClass.add(this.inputCategoriesContainer, "egoAnimated_fadingHourglassOverlay w3-disabled");
        
        this.RequestManager.post(
            requestUrl,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onLoadReferenceCatalogsResult),
            lang.hitch(this, this._onLoadReferenceCatalogsError),
            false // sync
        );
    }

    private _onLoadReferenceCatalogsResult(data: any) {

        let categoriesPreset: Array<string> = [];
        let alreadySelectedCategories = (<Array<EvServiceCategoryEntry>>this.selectedCategories).map(function (assignment) {
            return assignment.categoryID;
        });

        if (alreadySelectedCategories.length > 0) categoriesPreset = alreadySelectedCategories;
        else categoriesPreset = this.input_Category.getValue();

        this.input_Category.setData(categoriesPreset, data.serviceCategories);
        this.input_Unit.setData(this.sourceData?.ref_service_unit?.ID, data.serviceUnits, "ID", "description", true);
    //    this.input_TaskDescript.setData(null, data.dutyTypes, "ID", "description", true);

        this.UiModder.domClass.remove(this.inputCategoriesContainer, "egoAnimated_fadingHourglassOverlay w3-disabled");
    }
    private _onLoadReferenceCatalogsError(error: more.requestErrorMessage) {

        alert("error loading catalogs!\r\n" + error.Message)
    }

    //closeTaskDescriptEdit(): void {

    //    this.input_TaskDescript.editForm?.close();
    //}
  
    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        on(this, "CatalogEntityData_Save", () => {
            this.input_Category.setValue(null, true);
        });

        this.entityClass = MainCatalogs_Classes.EvServices;
        // enums durchiterieren ist sch.... aber so gehts halbwegs.
        for (let svcType in EvService_Types) {

            let value: any = EvService_Types[svcType];
            console.log(value);

            if (!isNaN(value)) {
                this.input_Type.addOption(
                    value.toString(),
                    this.translations["service_type_" + value.toString()], 
                    true);
            }
        }
    

        this.input_Type.constructOptions();

        this.loadReferenceCatalogs();

        //this.input_TaskDescript.placeAt(this.taskDescriptMainContainer);
        //this.UiModder.domClass.add(this.input_TaskDescript.domNode, "w3-margin-left w3-margin-right sectionBG overflow");

        //on(this.input_TaskDescript, "change", lang.hitch(this, this._onChangeInputDataGeneric));

        //on(this, "MainCatalogSelect_ShowHideAddChange", lang.hitch(this, this.closeTaskDescriptEdit));
        //on(this, "CatalogEntityData_Save", lang.hitch(this, this.closeTaskDescriptEdit));

        //this.input_Price.setNumberType("currency");
        this.input_Price.setUnit("€");
        this.input_Price.setPlaces(2);
        this.input_Price.setStep("0.01");
        //this.input_Description_E.setMandatory(false);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(EvServiceEditor.prototype, {
  input_TaskDescript: () => (new SearchSelect()),
  checkbox_FreePricePosition: () => (new CheckBox()),
});
export default mdsWidget(EvServiceEditor);
